export default __webpack_public_path__ + "static/media/adsform-sec2-bg.0a1d29e4.jpg";